import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Overlay } from '@r1-frontend/ui-kit/atoms/overlay';
import { PopupContent } from '@r1-frontend/ui-kit/molecules/Popup/components/PopupContent';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

export type TSheetProps = {
    /**
     * Отображение листа
     */
    isOpen: boolean,

    /**
     * Коллбек, вызываемый при закрытии листа
     */
    onClose: () => void,

    className?: string,
    children?: ReactNode,
}

const Sheet = styled((props: TSheetProps) => (
    <Overlay {...props}>
        <article role={'dialog'}>
            <span aria-label='pull-notch' onClick={props.onClose}/>

            <PopupContent>
                {props.children}
            </PopupContent>
        </article>
    </Overlay>
))`
    ${({ theme, isOpen }: ThemedProperties<TSheetProps>) => css`
        article[role='dialog'] {
            display: flex;
            flex-direction: column;
            overflow: hidden;

            padding: ${theme.indents.m}px;
            padding-bottom: ${theme.indents.l}px;

            background-color: ${theme.colors.system.background};
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;

            border-top-left-radius: ${theme.radii.pixel.xl}px;
            border-top-right-radius: ${theme.radii.pixel.xl}px;

            @keyframes elevate {
                from {
                    transform: translateY(100%);
                }
            }

            animation: elevate 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);

            max-height: calc(100% - ${theme.indents.xxxxxl}px);
            height: auto;

            ${PopupContent} {
                button {
                    width: 100%;
                }
            }

            span[aria-label="pull-notch"] {
                position: absolute;
                top: ${theme.indents.xxs}px;
                left: 50%;
                transform: translateX(-50%);
                border-radius: ${theme.radii.pixel.m}px;
                background-color: ${theme.colors.system.deep};

                cursor: pointer;

                width: 47px;
                height: 4px;
            }

            ${!isOpen && `
                transform: translateY(100%);
                transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
            
            `}
        }
    `};
`;

Sheet.displayName = 'Sheet';

export { Sheet };
